<template>
    <div @click="gobalClick">
        <el-dialog
            v-el-drag-dialog
            :before-close="handleClose"
            :visible.sync="selectUser"
            width="45%"
            title="查看详情"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <span slot="footer" class="dialog-footer">
                <el-button @click="selectUser = false">取 消</el-button>
            </span>
        </el-dialog>
        <transition name="subname">
            <div
                @click="selfShow"
                v-show="sublistShow"
                class="subCard"
                ref="subCard"
            >
                <el-card>
                    <el-row style="padding-bottom: 12px">
                        <el-col>
                            <span style="padding: 8px 0">子表详情</span>
                            <el-button
                                type="danger"
                                icon="el-icon-close"
                                circle
                                size="mini"
                                class="pull-right"
                                @click="closeSub"
                            ></el-button>
                        </el-col>
                    </el-row>
                    <el-table
                        :data="detailData"
                        size="mini"
                        style="width: 100%"
                        border
                    >
                        <el-table-column
                            prop="id"
                            label="支付方式编码"
                        ></el-table-column>
                        <el-table-column
                            prop="name"
                            label="支付方式"
                        ></el-table-column>
                        <el-table-column
                            prop="sumMoney"
                            label="支付金额"
                        ></el-table-column>
                    </el-table>
                </el-card>
            </div>
        </transition>
        <div
            class="padding7 el-card"
            v-loading="openloading"
            :element-loading-text="loadingText"
            element-loading-background="rgba(0, 0, 0, 0.1)"
        >
            <el-form
                :model="voucherQueryModel"
                label-width="120px"
                label-position="left"
            >
                <div>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item
                                label="品牌"
                                label-width="50px"
                                :required="true"
                            >
                                <el-select
                                    v-model="voucherQueryModel.brandId"
                                    placeholder="选择品牌"
                                    size="mini"
                                    class="width100"
                                    @change="brandChange"
                                    filterable
                                >
                                    <el-option
                                        v-for="item in brandList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="8">
                            <el-form-item
                                label="制单日期"
                                label-width="80px"
                                :required="true"
                            >
                                <el-date-picker
                                    v-model="time"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    size="mini"
                                    style="width: 100%"
                                    @change="timeChange"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="top7">
                            <el-button
                                type="primary"
                                size="mini"
                                icon="el-icon-download"
                                class="pull-right"
                                @click="voucherCreateShow"
                                :disabled="!isSearchVal"
                                >生成凭证</el-button
                            >
                            <el-button
                                type
                                size="mini"
                                icon="el-icon-search"
                                class="pull-right right-20"
                                @click="search"
                                >查询</el-button
                            >
                        </el-col>
                    </el-row>
                </div>
            </el-form>

            <el-table
                :data="tableData"
                ref="tableData"
                size="mini"
                style="width: 100%"
                border
                @row-click="clickRow"
            >
                <el-table-column label="起止日期" width="200">
                    <template slot-scope="scope">
                        <span
                            :class="scope.row.color"
                            style="margin-right: 10px"
                        ></span>
                        {{ dateFormat(scope.row.startTime) }}/{{
                            dateFormat(scope.row.endTime)
                        }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="billMoney"
                    label="账单消费"
                ></el-table-column>
                <el-table-column
                    prop="consumeTime"
                    label="消费次数"
                ></el-table-column>
                <el-table-column
                    prop="chargeMoney"
                    label="充值应收"
                ></el-table-column>
                <el-table-column
                    prop="realChargeMoney"
                    label="充值实收"
                ></el-table-column>
                <el-table-column
                    prop="chargeCount"
                    label="充值次数"
                ></el-table-column>
            </el-table>
            <pagerBar
                ref="refPagerBar"
                :apiURL="VoucherDataApi"
                :GetData="getTableData"
                :queryParam="queryParam"
                :isInit="false"
                :errorFunc="errorHandler"
            ></pagerBar>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    data() {
        return {
            loadingText: '加载中',
            openloading: false,
            sublistShow: false, //子表默认隐藏,
            selectUser: false,
            isSearchVal: false,
            isVoucherCreate: false,
            queryParam: {},
            CurrnetMID: 0,
            VoucherCreateApi: config.BASE_Middle_API + 'VoucherCreate',
            VoucherDataApi:
                config.BASE_Middle_API + 'VoucherCreate/GetCrmReportData', //获取源数据接口 需提供
            Visible: false,
            optionsList: [],
            moduleList: [],
            brandList: [],
            brands: [],
            tableData: [],
            detailData: [],
            time: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],
            voucherQueryModel: {
                startTime: moment().format('YYYY-MM-DD'),
                endTime: moment().format('YYYY-MM-DD'),
                brandId: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            const end = start
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            const starttime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .startOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')
                            const endtime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .endOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')

                            picker.$emit('pick', [starttime, endtime])
                        }
                    },
                    {
                        text: '本月',
                        onClick: (picker) => {
                            let start = new Date(
                                moment()
                                    .startOf('month')
                                    .format('YYYY-MM-DD HH:mm:ss')
                            )
                            let end = new Date(
                                moment()
                                    .endOf('days')
                                    .format('YYYY-MM-DD HH:mm:ss')
                            )
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            }
        }
    },
    props: {
        tabType: {
            type: String,
            required: true
        }
    },
    components: { pagerBar },
    mounted() {
        this.getModules()
    },
    methods: {
        openloadingHander() {
            this.openloading = true
        },
        closeloadingHander() {
            this.openloading = false
        },
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                function (c) {
                    var r = (Math.random() * 16) | 0,
                        v = c == 'x' ? r : (r & 0x3) | 0x8
                    return v.toString(16)
                }
            )
        },
        gobalClick() {
            // 点击空白处隐藏弹窗方法
            this.sublistShow = false
        },
        clickRow(row, column, event) {
            event.stopPropagation()
            this.detailData = row.chargePay
            this.sublistShow = true
            //点击空白处关闭弹窗
        },
        selfShow(e) {
            e.stopPropagation()
            this.sublistShow = true
        },
        closeSub(e) {
            //关闭右侧弹窗
            e.stopPropagation()
            this.sublistShow = false
        },
        dateFormat(val) {
            return moment(val).format('YYYY-MM-DD')
        },
        timeChange(val) {
            this.voucherQueryModel.startTime = moment(val[0]).format(
                'YYYY-MM-DD'
            )
            this.voucherQueryModel.endTime = moment(val[1]).format('YYYY-MM-DD')
        },
        errorHandler() {
            this.closeloadingHander()
        },
        search() {
            this.openloadingHander()
            this.queryTick = this.guid()
            cf.event.on('app.chat.messageReceived', function (message) {
                if (this.queryTick === message.sharedMessageId) {
                    this.loadingText = message.message
                }
            })
            this.loadingText = '加载中'

            let confirmData = Object.assign(
                { tick: this.queryTick },
                this.voucherQueryModel
            )
            this.queryParam = Object.assign({}, confirmData)
        },
        voucherCreateShow() {
            const _this = this
            _this.openloadingHander()
            _this.queryTick = _this.guid()
            cf.event.on('app.chat.messageReceived', function (message) {
                if (_this.queryTick === message.sharedMessageId) {
                    _this.loadingText = message.message
                }
            })
            _this.loadingText = '加载中'
            //凭证生成接口
            const confirmData = {
                brandID: _this.queryParam.brandId,
                startTime: _this.queryParam.startTime,
                endTime: _this.queryParam.endTime
            }
            let saveData = Object.assign({ tick: _this.queryTick }, confirmData)
            let queryDatas = Object.assign({}, saveData)
            AjaxHelper.post(
                _this.VoucherCreateApi + '/CrmReportDataHandle',
                queryDatas
            )
                .then(function (response) {
                    if (response.result.isSuccess) {
                        {
                            _this.$notify({
                                title: '提示',
                                message: response.result.successMsg,
                                type: 'success',
                                position: 'bottom-right',
                                duration: 0
                            })
                        }
                    } else {
                        _this.$notify({
                            title: '提示',
                            message: response.result.errorMsg,
                            type: 'error',
                            position: 'bottom-right',
                            duration: 0
                        })
                    }
                    _this.closeloadingHander()
                })
                .catch(function (error) {
                    _this.closeloadingHander()
                })
        },
        getTableData(d) {
            const _this = this
            _this.tableData = d
            //查询无结果 不允许生成凭证
            if (d.length > 0) {
                _this.isSearchVal = true
            } else {
                _this.isSearchVal = false
            }

            if (_this.selOrder.length) {
                _this.selOrder.forEach((item) => {
                    if (item.key == _this.$refs.refPagerBar.currentPage) {
                        _this.toggleSelection(item.value)
                    }
                })
            }

            _this.closeloadingHander()
        },
        brandChange(val) {
            this.isSearchVal = false
        },
        statusSearch(item) {
            this.CurrnetMID = item.id
            this.voucherQueryModel.brandId = ''
            this.brandList = this.brands.filter((x) => x.moduleID == item.id)
            this.isSearchVal = false
        },
        getModules() {
            const _this = this
            this.openloadingHander()
            AjaxHelper.get(
                _this.VoucherCreateApi + '/GetModules?tabType=' + _this.tabType
            )
                .then(function (response) {
                    if (response.success) {
                        _this.moduleList = response.result.modules
                        if (_this.moduleList.length > 0) {
                            const firstItem = _this.moduleList[0]
                            _this.CurrnetMID = firstItem.id
                            _this.brands = response.result.brands
                            _this.stores = response.result.stores
                            _this.brands.forEach((x) => {
                                _this.moduleList.forEach((element) => {
                                    if (element.id == x.moduleID) {
                                        _this.brandList.push(x)
                                    }
                                })
                            })
                        }
                    }
                    _this.closeloadingHander()
                })
                .catch(function (error) {
                    _this.closeloadingHander()
                })
        },
        handleClose(done) {
            this.isVoucherCreate = false
            done()
        }
    }
}
</script>

<style scoped>
.minicard {
    height: auto !important;
    display: block;
    width: 200px;
    position: absolute;
    right: 0;
    z-index: 9989;
    top: 80px;
}
.minicard .el-button {
    width: 150px;
    margin: 5px 0;
}
.el-dialog__body {
    padding: 10px 15px !important;
}

dl.loglist p {
    font-weight: 600;
    margin: 20px 0 10px 0;
}
dl.loglist dd {
    padding: 15px 0;
    color: #999999;
    display: block;
}
.subname-enter-active,
.subname-leave-active {
    transition: opacity 0.6s;
}
/*指定隐藏时的样式*/

.subname-enter,
.subname-leave-to {
    opacity: 0;
}

.subCard {
    position: absolute;
    z-index: 2900;
    width: 55%;
    right: 0;
}
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}
.w25 {
    width: 25%;
    float: left;
}
.w75 {
    width: 75%;
    float: left;
}
.el-card {
    border: 0;
    height: calc(100vh - 225px);
    overflow-y: auto;
}
.padding7 {
    padding: 7px;
}
.top7 {
    padding: 7px 0 0 0;
}
</style>
